// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__Ez5O6","label":"styles_label__Tut82"};